import React from "react";
import 'semantic-ui-css/semantic.min.css';
import "./App.css";

import Dashboard from "./pages/Dashboard";
import Home from "./pages/Home";
import Rooms from "./pages/Rooms";
import SingleRoom from "./pages/SingleRoom";
import Error from "./pages/Error";
//import { Container } from 'semantic-ui-react

import Menubar from "./components/Menubar";
import Navbar from "./components/Navbar";
import Pricing from "./components/Pricing"
//import Blog from "./components/Blog"
import Footer from "./components/Footer"
import Register from "./pages/Register"
import Login from "./pages/Login"
import  {AuthProvider} from "./context/auth"

import { Switch, Route } from "react-router-dom";

function App() {
  return (
    <AuthProvider>
      <>
      {/* <Menubar/> */}
      <Navbar /> 
      <Switch>
        
         <Route exact path="/" component={Home} />
       <Route exact path="/dashboard" component={Dashboard} />
        <Route exact path="/rooms/" component={Rooms} />
        <Route exact path="/rooms/:slug" component={SingleRoom} />
        <Route exact path="/pricing/" component={Pricing} />
         <Route exact path="/register/" component={Register} />
          <Route exact path="/login/" component={Login} />
  
           <Route exact path="/menubar/" component={Menubar} />


        <Route component={Error} />
      </Switch>
      <Footer></Footer>
    </>
    </AuthProvider>
  );
}

export default App;
